export default "__VITE_ASSET__3b586cc1__"